import React from "react";
import CheckIcon from '../../assets/images/check-white.svg';
import HandCartIcon from '../../assets/images/referralConfirmation/hand-cart.svg';
import CalendarIcon from '../../assets/images/referralConfirmation/CalendarIcon.svg';
import ReceiptIcon from '../../assets/images/referralConfirmation/Receipt.svg';
import PaperclipIcon from '../../assets/images/referralConfirmation/paperclip.svg';
import { DoctorDetails, Image } from "../../components/componentIndex";
import DoctorProfile from '../../assets/images/dashboard/profile-1.svg';

const ReferralConfirmation = () => {

    const referralPatient = [
        {
            doctorInfo: {
                name: 'Jessica Johnson, MD',
                specialization: 'Gastroenterology',
                address: 'Novant Medical Center',
                rating: '4.0 (102)',
                photo: DoctorProfile
            }
        },
    ];

    const handleDownload = async () => {
        const response = await fetch(DoctorProfile);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'downloaded-image.jpg'); // Set file name
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link); // Clean up
    };

    return (
        <div className="custom-container">
            <div className="referral-form">
                <h4 className="page-title">Referral confirmation</h4>

                <div className="row">
                    <div className="col-md-7">
                        <div className="message-content">
                            <div className="success-circle">
                                <Image imgUrl={CheckIcon} altText={'check'} />
                            </div>
                            <p className="success-message mb-0">Referral submitted successfully!</p>
                        </div>
                        <div className="patient-info-card">
                            <p className="confirmation-label mt-4 mb-0">Confirmation #:</p>
                            <p className="confirmation-number">S475Y66</p>
                            <p className="description">The patient will receive a text and email to schedule their procedure.
                                You’ll be notified once they complete the booking.</p>
                            <div className="divider my-3"></div>
                            <div className="patient-details">
                                <h5 className="title mb-4">Patient information</h5>
                                <div className="d-flex justify-content-start align-items-start">
                                    <div className="referral-patient-info">
                                        <div className="d-flex justify-content-start align-items-start">
                                            <Image imgUrl={HandCartIcon} altText={'Hand Cart'} />
                                            <p className="title-name px-3">Patient name:</p>
                                        </div>
                                    </div>
                                    <div className="">
                                        <p className="title-name"><span className="name">Helena Alvarez</span></p>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-start align-items-start">
                                    <div className="referral-patient-info">
                                        <div className="d-flex justify-content-start align-items-start">
                                            <Image imgUrl={CalendarIcon} altText={'Hand Cart'} />
                                            <p className="title-name px-3">Date of birth:</p>
                                        </div>
                                    </div>
                                    <div className="">
                                        <p className="title-name"> <span className="name">03/28/1975</span></p>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-start align-items-start">
                                    <div className="referral-patient-info">
                                        <div className="d-flex justify-content-start align-items-start">
                                            <Image imgUrl={ReceiptIcon} altText={'Hand Cart'} />
                                            <p className="title-name px-3">Procedure:</p>
                                        </div>
                                    </div>
                                    <div className="">
                                        <p className="title-name"><span className="name">Colonoscopy</span></p>
                                    </div>
                                </div>

                            </div>
                            <div className="divider my-3"></div>
                            <h5 className="attachments-title">Attachments</h5>
                            <div className="attached-file-name" >
                                <Image imgUrl={PaperclipIcon} altText={'Hand Cart'} className={'attach-icon'} />
                                <p className="file-name" >HELENAALVAREZ.PDF</p>
                            </div>
                            <div className="attachments btn-upload cursor-pointer" onClick={handleDownload} download>
                                <p className="name mb-0">Download referral PDF</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="visits p-0 referral-patient-list">
                            {referralPatient.map((item, index) => (
                                <div className="visits-card card mt-0" key={index}>
                                    <DoctorDetails doctorInformation={item?.doctorInfo} />
                                    <div className="divider my-3"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ReferralConfirmation;